import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API = "https://stu168523.webhosting.arden.ac.uk";

export default function QuizAttempt() {
  const { id } = useParams();
  const [quizzes, setQuizzes] = useState([]);
  const [answer, setAnswer] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/api/quizzes/category/${id}`)
      .then((r) => setQuizzes(r.data));
  }, [id]);

  const submit = async (quizId) => {
    await axios.post(
      `${API}/api/quizzes/submit`,
      { quizId, answer },
      { headers: { authorization: localStorage.getItem("token") } }
    );
    alert("Submitted");
  };

  return quizzes.map((q) => (
    <div key={q._id}>
      <h4>{q.question}</h4>
      {q.options.map((o, i) => (
        <label key={i}>
          <input type="radio" name="opt" onChange={() => setAnswer(i)} />
          {o}
        </label>
      ))}
      <button onClick={() => submit(q._id)}>Submit</button>
    </div>
  ));
}
